import { useQuery } from "@tanstack/react-query";
import { fetchConnectionsData } from "@app/services/connectionsApi";
import type { ConnectionsPayload } from "@shared/types/connections";

export const CONNECTIONS_QUERY_KEY = ["dashboard", "connections"] as const;

export function useConnectionsData() {
  return useQuery<ConnectionsPayload>({
    queryKey: CONNECTIONS_QUERY_KEY,
    queryFn: fetchConnectionsData,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}

